import type { EligibilityFormData } from '../types'

export function shouldShowAdditionalInfoTrainingQuestions({
  formData,
  storedProgramExternalId,
  isSelectedProgramYardOnly
}: {
  formData: EligibilityFormData
  storedProgramExternalId?: string
  isSelectedProgramYardOnly: boolean
}): boolean {
  return Boolean(formData.selectedProgram || storedProgramExternalId) && !isSelectedProgramYardOnly
}

export function getAdditionalInfoSelectionError({
  shouldShowLaptopQuestion,
  trainingMode,
  hasLaptop
}: {
  shouldShowLaptopQuestion: boolean
  trainingMode: EligibilityFormData['trainingMode']
  hasLaptop: EligibilityFormData['hasLaptop']
}): string | null {
  if (!shouldShowLaptopQuestion) {
    return null
  }

  if (!trainingMode) {
    return 'Please choose how you would like to attend classroom theory training.'
  }

  if (trainingMode === 'remote' && hasLaptop !== true && hasLaptop !== false) {
    return 'Please indicate whether you have access to a laptop with camera.'
  }

  return null
}
